import { Link } from 'react-router-dom'

function Footer() {
  return (
    <footer className="relative z-10 mt-8 border-t border-white/10 bg-black/80">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2">
              <img
                src="https://static.lumi.new/f4/f4a3f87cac571f6c3dd0b7f47b53b4fb.webp"
                alt="Penguin Pad logo - penguin mascot next to the PenguinPad.xyz wordmark"
                className="h-14 w-auto"
              />
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
              Permissionless bonding curves and community presales on Robinhood Chain. No KYC.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500">Product</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/launchpad" className="transition-colors hover:text-lime-400">Launchpad</Link></li>
              <li><Link to="/presale" className="transition-colors hover:text-orange-400">Presale</Link></li>
              <li><Link to="/how-it-works" className="transition-colors hover:text-white">How it works</Link></li>
              <li><Link to="/presale-vs-quick-launch" className="transition-colors hover:text-white">Presale vs. Quick Launch</Link></li>
              <li><Link to="/terms" className="transition-colors hover:text-white">Terms</Link></li>
              <li><Link to="/disclaimer" className="transition-colors hover:text-white">Disclaimer</Link></li>
              <li>
                <a
                  href="https://github.com/PenguinSwapRobinhood"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors hover:text-white"
                >
                  GitHub
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500">Community</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-zinc-400">
              <li><Link to="/explore-colony" className="transition-colors hover:text-white">Explore the Colony</Link></li>
              <li><Link to="/colony-newsfeed" className="transition-colors hover:text-white">Colony Newsfeed</Link></li>
              <li><Link to="/my-colony" className="transition-colors hover:text-white">My Colony</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-zinc-500">Follow</h3>
            <div className="mt-4 flex gap-3">
              <a
                href="https://x.com/PenguinPad_xyz"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Penguin Pad on X"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-zinc-400 transition-all hover:border-lime-400/40 hover:text-lime-400"
              >
                <svg
                  viewBox="0 0 24 24"
                  className="h-4 w-4"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs text-zinc-500 sm:flex-row">
          <p>© {new Date().getFullYear()} Penguin Pad. All rights reserved.</p>
          <p className="flex flex-wrap items-center gap-x-3 gap-y-1">
            <Link to="/terms" className="hover:text-lime-400">Terms</Link>
            <Link to="/disclaimer" className="hover:text-lime-400">Disclaimer</Link>
            <span>Robinhood Chain. No KYC. Do your own research.</span>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
